import { FormattedMessage } from 'react-intl'
import { Button } from '@mui/material'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import { Link } from 'react-router-dom'
import { any, equals } from 'ramda'
import { useAnalytics, useCurrentAppType } from 'hooks'

const SearchBlock = () => {
  const { isBusiness, isWellpower, isNLC } = useCurrentAppType()
  const { sendEvent } = useAnalytics()

  const getText = () => {
    if (any(equals(true))([isWellpower, isNLC])) {
      return (
        <FormattedMessage
          defaultMessage='Try searching for "stress" or "finances"'
          id="DqgudF"
        />
      )
    }
    if (isBusiness) {
      return (
        <FormattedMessage
          defaultMessage='Try searching for "career" or "stress"'
          id="WuexYy"
        />
      )
    }
  }

  return (
    <Button
      LinkComponent={Link}
      onClick={() =>
        sendEvent('block_interactions', {
          block_title: 'Explore Search Block',
          click_element: 'Button',
          element_title: 'search',
          path: window.location.pathname
        })
      }
      startIcon={<SearchRoundedIcon />}
      sx={{
        alignSelf: 'center',
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'secondary.main',
        color: 'secondary.dark',
        fontFamily: 'mark-ot',
        // eslint-disable-next-line sort-keys
        fontSize: { xs: 14, md: 20 },
        margin: '16px auto',
        textTransform: 'capitalize'
      }}
      to="/search"
      variant=""
    >
      {getText()}
    </Button>
  )
}

export default SearchBlock
